<template>
  <div class="home-page">
    <div class="ew-login-layout">
      <div class="container no-padding">
        <div class="row align-items-center">
          <!-- FORMULARIO -->
          <div class="col-lg-6 col-md-8 mx-auto">
            <div class="ew-login-form p-5 shadow rounded bg-white">
              <div class="text-center mb-4">
                <router-link to="/">
                  <img class="ew-login-logo mb-3" src="@/assets/images/sack/logo.png" alt="Logo SackEnvios" />
                </router-link>
                <h2 class="mb-1">Crear cuenta</h2>
                <p class="text-muted">Completa el formulario para comenzar a usar nuestros servicios.</p>
              </div>

              <p class="text-center ew-login-signup-hint mb-4">
                ¿Ya tienes cuenta?
                <router-link to="/signin" class="font-weight-bold">Inicia sesión aquí</router-link>
              </p>

              <form @submit.prevent="signup" novalidate>
                <!-- Nombre y Apellido -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label>
                      Nombre <sup>*</sup>
                    </label>
                    <input type="text" class="form-control" v-model="firstName" required @input="$v.firstName.$touch()"
                      :class="{ 'is-invalid': $v.firstName.$error }" />
                    <div class="invalid-feedback">Introduce tu nombre.</div>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label>
                      Apellido <sup>*</sup>
                    </label>
                    <input type="text" class="form-control" v-model="lastName" required @input="$v.lastName.$touch()"
                      :class="{ 'is-invalid': $v.lastName.$error }" />
                    <div class="invalid-feedback">Introduce tu apellido.</div>
                  </div>
                </div>

                <!-- Correo -->
                <div class="mb-3">
                  <label>
                    Correo electrónico <sup>*</sup>
                  </label>
                  <input type="email" class="form-control" v-model="email" required @input="$v.email.$touch()"
                    :class="{ 'is-invalid': $v.email.$error }" />
                  <div class="invalid-feedback">Introduce un correo electrónico válido.</div>
                </div>

                <!-- Teléfono -->
                <div class="mb-3">
                  <label>
                    Teléfono <sup>*</sup>
                  </label>
                  <input type="tel" class="form-control" v-model="phone" required @input="$v.phone.$touch()"
                    :class="{ 'is-invalid': $v.phone.$error }" placeholder="Ej. 5512345678" />
                  <div class="invalid-feedback">Introduce un número de teléfono válido.</div>
                </div>

                <!-- Contraseña -->
                <div class="mb-3">
                  <label>
                    Contraseña <sup>*</sup>
                  </label>
                  <input type="password" class="form-control" v-model="password" required @input="$v.password.$touch()"
                    :class="{ 'is-invalid': $v.password.$error }" />
                  <div class="invalid-feedback">
                    La contraseña debe tener entre {{ $v.password.$params.minLength.min }} y
                    {{ $v.password.$params.maxLength.max }} caracteres.
                  </div>
                </div>

                <!-- Confirmación -->
                <div class="mb-3">
                  <label>
                    Repetir Contraseña <sup>*</sup>
                  </label>
                  <input type="password" class="form-control" v-model="passwordConfirm" required
                    @input="$v.passwordConfirm.$touch()" :class="{ 'is-invalid': $v.passwordConfirm.$error }" />
                  <div class="invalid-feedback">Las contraseñas no coinciden.</div>
                </div>

                <div class="text-center">
                  <button type="submit" class="btn btn-lg btn-primary px-5" :disabled="$v.$invalid">
                    Crear cuenta
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Imagen lateral -->
          <div class="col d-none d-lg-block ew-login-pattern"></div>
        </div>
      </div>
    </div>
    <!-- Footer global -->
    <AppFooter />
  </div>
</template>

<style scoped>
.ew-login-layout {
  background: #f5f7fa;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.ew-login-form {
  background: #fff;
  border-radius: 16px;
  max-width: 700px;
}

.ew-login-logo {
  max-width: 180px;
}


.flotante {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #25d366;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.flotante img {
  width: 40px;
  height: 40px;
}
</style>

<script>
import AppFooter from "@/components/AppFooter.vue";
import axios from 'axios'
import commons from '../commons'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  sameAs
} from 'vuelidate/lib/validators'

export default {
  name: 'SignUp',
  components: {
    AppFooter
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      password: '',
      passwordConfirm: '',
      website: '',
      email: '',
      phone: '',
      rol: 'user'
    }
  },
  methods: {
    signup() {
      axios
        .post(`${commons.apiURL}/api/v1/users`, {
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          website: this.website,
          email: this.email,
          phone: this.phone,
          rol: 'user'
        })
        .then(response => {
          this.$router.push('/signin?newUser=true')
        })
        .catch(error => {
          console.error(error)
        })
    },
    ...mapActions(['quoting', 'newShipment', 'getAllShipments']),
    ...mapMutations(['setNewShipmentRequestBody'])
  },
  computed: {
    ...mapGetters(['newShipmentRequestBody'])
  },
  validations: {
    firstName: {
      required,
      maxLength: maxLength(35)
    },
    lastName: {
      required,
      maxLength: maxLength(35)
    },
    email: {
      required,
      email,
      maxLength: maxLength(100)
    },
    phone: {
      required,
      maxLength: maxLength(10)
    },
    password: {
      required,
      minLength: minLength(4),
      maxLength: maxLength(12)
    },
    passwordConfirm: {
      sameAsPassword: sameAs('password')
    },
    website: {
      url
    }
  },
  created() {
    if (localStorage.getItem('ew-user-id')) {
      this.$router.push('/dashboard')
      console.log('you are logged in')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignUp.vue